export const OFFICE_PHONE = '+1 855 982-2835';
export const OFFICE_FAX = '+1 438 605-5447';
export const COMPANY_WEBSITE = 'https://www.atek.io';
export const COMPANY_TAGLINE = "Monitoring Made Simple — We've got your back.";
const COBALT = '#5A1DEF';
const MIDNIGHT = '#1C143D';
const SLATE = '#404041';
const LIGHT = '#8a8a8a';
const PUBLIC_ASSETS_BUCKET = 'https://storage.googleapis.com/atek-public-assets';
const LOGO_URL = `${PUBLIC_ASSETS_BUCKET}/brand/logos/atek-logo-horizontal-dark-medium.png`;
/**
 * Build the ATEK email signature as a self-contained HTML fragment.
 *
 * - 'new' mode: full signature with logo + tagline (for new emails)
 * - 'reply' mode: compact one-line-style block without logo/tagline
 *
 * Outlook-friendly table layout with inline styles for Gmail compatibility.
 */
export function buildSignatureHtml(f, mode, photoDataUrl) {
    const fullName = `${f.firstName} ${f.lastName}`.trim() || 'Your Name';
    const title = f.title || 'Your Title';
    const linkStyle = `color:${COBALT};text-decoration:none;`;
    const mutedStyle = `color:${SLATE};`;
    const ext = f.extension.trim();
    const officeDigits = OFFICE_PHONE.replace(/[^\d+]/g, '') + (ext ? `,${ext}` : '');
    const officeDisplay = ext ? `${OFFICE_PHONE} x${ext}` : OFFICE_PHONE;
    const phoneRow = `<tr><td style="font:13px/1.4 Poppins,Arial,sans-serif;${mutedStyle}padding:2px 0;">T&nbsp;<a href="tel:${officeDigits}" style="${linkStyle}">${officeDisplay}</a></td></tr>`;
    const mobileRow = f.mobile
        ? `<tr><td style="font:13px/1.4 Poppins,Arial,sans-serif;${mutedStyle}padding:2px 0;">M&nbsp;<a href="tel:${f.mobile.replace(/[^\d+]/g, '')}" style="${linkStyle}">${f.mobile}</a></td></tr>`
        : '';
    const faxRow = `<tr><td style="font:13px/1.4 Poppins,Arial,sans-serif;${mutedStyle}padding:2px 0;">F&nbsp;<span style="color:${SLATE};">${OFFICE_FAX}</span></td></tr>`;
    const emailRow = f.email
        ? `<tr><td style="font:13px/1.4 Poppins,Arial,sans-serif;padding:2px 0;"><a href="mailto:${f.email}" style="${linkStyle}">${f.email}</a></td></tr>`
        : '';
    const webRow = `<tr><td style="font:13px/1.4 Poppins,Arial,sans-serif;padding:2px 0;"><a href="${COMPANY_WEBSITE}" style="${linkStyle}">${COMPANY_WEBSITE.replace(/^https?:\/\//, '')}</a></td></tr>`;
    const linkedinRow = f.linkedin
        ? `<tr><td style="font:13px/1.4 Poppins,Arial,sans-serif;padding:2px 0;"><a href="${f.linkedin}" style="${linkStyle}">LinkedIn</a></td></tr>`
        : '';
    if (mode === 'reply') {
        const separator = `<span style="color:${LIGHT};margin:0 6px;">·</span>`;
        const phoneInline = `<a href="tel:${officeDigits}" style="${linkStyle}">${officeDisplay}</a>`;
        const mobileInline = f.mobile ? `<a href="tel:${f.mobile.replace(/[^\d+]/g, '')}" style="${linkStyle}">${f.mobile}</a>` : '';
        const emailInline = f.email ? `<a href="mailto:${f.email}" style="${linkStyle}">${f.email}</a>` : '';
        const webInline = `<a href="${COMPANY_WEBSITE}" style="${linkStyle}">${COMPANY_WEBSITE.replace(/^https?:\/\//, '')}</a>`;
        const contactBits = [phoneInline, mobileInline, emailInline, webInline].filter(Boolean).join(separator);
        return `<table cellpadding="0" cellspacing="0" border="0" style="font-family:Poppins,Arial,sans-serif;color:${SLATE};">
  <tr>
    <td width="3" style="background-color:${COBALT};width:3px;min-width:3px;">&nbsp;</td>
    <td width="18" style="width:18px;min-width:18px;">&nbsp;</td>
    <td style="vertical-align:top;">
      <div style="font-family:'Work Sans',Arial,sans-serif;font-weight:500;font-size:14px;color:${MIDNIGHT};">${fullName}<span style="color:${LIGHT};font-weight:300;"> — ${title}</span></div>
      <div style="font:12px/1.5 Poppins,Arial,sans-serif;color:${SLATE};padding-top:2px;">${contactBits}</div>
    </td>
  </tr>
</table>`;
    }
    const photoBlock = photoDataUrl
        ? `<div style="margin-bottom:12px;text-align:center;">
        <img src="${photoDataUrl}" alt="${fullName}" width="96" height="96" style="display:inline-block;border:0;width:96px;height:96px;border-radius:50%;object-fit:cover;" />
      </div>`
        : '';
    return `<table cellpadding="0" cellspacing="0" border="0" style="font-family:Poppins,Arial,sans-serif;color:${SLATE};">
  <tr>
    <td style="padding-right:18px;border-right:3px solid ${COBALT};vertical-align:top;">
      ${photoBlock}
      <a href="${COMPANY_WEBSITE}" style="display:inline-block;">
        <img src="${LOGO_URL}" alt="ATEK" width="170" style="display:block;border:0;max-width:170px;" />
      </a>
    </td>
    <td style="padding-left:18px;vertical-align:top;">
      <div style="font-family:'Work Sans',Arial,sans-serif;font-weight:300;font-size:20px;letter-spacing:0.02em;color:${MIDNIGHT};text-transform:uppercase;">${fullName}</div>
      <div style="font:13px/1.4 Poppins,Arial,sans-serif;color:${LIGHT};margin-top:2px;margin-bottom:8px;">${title}</div>
      <table cellpadding="0" cellspacing="0" border="0">
        ${phoneRow}${mobileRow}${faxRow}${emailRow}${webRow}${linkedinRow}
      </table>
      <div style="font:italic 12px/1.4 Poppins,Arial,sans-serif;color:${LIGHT};margin-top:10px;">${COMPANY_TAGLINE}</div>
    </td>
  </tr>
</table>`;
}
//# sourceMappingURL=index.js.map